import React, { useEffect, useState } from 'react';
import styles from './Profile.module.css';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from './header/Header';
import AvailableDays from './available-days/AvailableDays';
import { RouterActions } from '../../redux/actions';

const Profile = props => {
  const { history, saveHistoryOnRedux } = props;

  useEffect(() => {
    saveHistoryOnRedux(history);
  }, []);

  return (
    <div>
      <Header />
      <div className={styles.cards}>
        <AvailableDays />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    saveHistoryOnRedux: history => dispatch(RouterActions.saveHistory(history))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Profile));
